import { AuthSettings } from './types';

export const settings: AuthSettings = {
    cookieName: 'gust',
    cookieExpire: 30 * 12,
};
